module.exports = __webpack_public_path__ + "static/media/folder-sel.78661550.svg";